import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

const questionnaires: RouteRecordRaw[] = [
  {
    ...SETTINGS.questionnaires.root,
    component: () => import("@/Views/settings/questionnaires/index.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "questionnaires.questionnaires-title",
    },
  },
];

export default questionnaires;
